// MyAgent Core Module
// Core agent orchestration with LLM execution and tool system

import { ToolCategory } from 'tool_sdk'
import { createNotesCategory } from 'myagent_notes/tools'
import { createNotificationCategory } from 'tool_sdk/tools/notification'
import { createWebCategory } from 'web_tools/tools'
import { MYAGENT_BOT_ID, buildBotSystemPrompt, MYAGENT_DEFAULT_CONFIG } from './prompts.js'

export { MYAGENT_BOT_ID, buildBotSystemPrompt, MYAGENT_DEFAULT_CONFIG }
export { createToolAgent } from './tool-agent.js'

/**
 * Build the root ToolCategory from category configuration.
 *
 * @param {Object} options
 * @param {Function} options.getWorkerClient - Function to get worker RPC client
 * @param {Object} options.categoryConfig - Category configuration
 * @returns {ToolCategory} Root category instance
 */
export function buildRootCategory({ getWorkerClient, categoryConfig }) {
  if (!categoryConfig?.notes?.publicKey && !categoryConfig?.notes?.getTarget) {
    throw new Error('buildRootCategory requires categoryConfig.notes.publicKey or notes.getTarget')
  }

  const { notes, searcher } = categoryConfig

  const categories = [
    createNotesCategory({ getWorkerClient, notesPublicKey: notes.publicKey, getTarget: notes.getTarget }),
    createNotificationCategory({ getWorkerClient }),
    createWebCategory({ getWorkerClient }),
  ]

  return new ToolCategory({
    id: '',
    description: 'Root category',
    tools: [],
    searcher,
    subCategories: categories,
  })
}
